import { Chip } from '@mui/material';
import { useState } from 'react';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { UpsertOptionValueDialog } from './UpsertOptionValueDialog';
import { LocalizedProductOptionValue } from '../../../../interfaces/ProductOption/ProductOptionKey';

interface OptionValueChipProps {
  value: LocalizedProductOptionValue;
  selectedLocale: string | null;
  onDelete?: () => void;
  onUpdate: (newValue: string) => void;
}

export const OptionValueChip = (props: OptionValueChipProps) => {
  const [clickedDelete, setClickedDelete] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);

  const resolvedName = props.selectedLocale
    ? props.value.nameTranslation[props.selectedLocale] ?? ''
    : props.value.name;

  return (
    <>
      {clickedDelete && (
        <ConfirmDialog
          content='Gerçekten seçili değeri silmek istiyor musunuz'
          open={clickedDelete}
          onClose={() => setClickedDelete(false)}
          onConfirm={() => {
            setClickedDelete(false);
            props.onDelete?.();
          }}
          color='error'
        />
      )}
      <UpsertOptionValueDialog
        initialValue={resolvedName}
        defaultValue={props.value.name}
        selectedLocale={props.selectedLocale}
        open={showUpdateDialog}
        onUpsert={(newValue) => {
          setShowUpdateDialog(false);
          props.onUpdate(newValue);
        }}
        onClose={() => setShowUpdateDialog(false)}
      />
      <Chip
        label={resolvedName || props.value.name}
        color={resolvedName ? 'primary' : 'error'}
        onClick={() => setShowUpdateDialog(true)}
        onDelete={
          props.onDelete && !props.selectedLocale
            ? () => setClickedDelete(true)
            : undefined
        }
      />
    </>
  );
};
